import HotTable from '@handsontable/react';
import React, { useMemo } from 'react'
import{useEffect,useRef,useState} from 'react'
import axios from 'axios';
import MaterialTable from '@material-table/core';
import '../App.css'
import { Box, Hidden, Typography } from '@mui/material';

const Home = () => {
  const [data, setData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  
    const url3 = "https://app.sheetlabs.com/COCO/indexreturns"
    // get api
    const getapi = async ()=>{
      
      try{
        const response= await axios.get(url3)
        setData(response.data)
       
      }catch(error){
        console.log(error);
      }

    }

    useEffect(() => {
  
      getapi();

      
    }, [])
   
    
 
    
  
    const columns = useMemo(()=>[
      
      {title:'Nifty Index',field:'NiftyIndex',width:200},
      {title:'LTP',field:'LTP',width:200},
      {title:'This Year Change',field:'ThisYearChange',width:200},
      {title:'This month change',field:'Thismonthchange',width:200},
      {title:'Support',field:'Support',width:200},
      {title:'Resitance',field:'Resistance',width:200},
    ],[])
    
    
  return (
    <div className="container mt-5 ">
       <MaterialTable
      title="INDEX"
      data={data}
      columns={columns}
      actions={[
        
      ]}
      cellEditable={{
        onCellEditApproved: (newValue, oldValue, rowData, columnDef) => {
          return new Promise((resolve, reject) => {
            console.log('newValue: ' + newValue);
            setTimeout(resolve, 1000);
          });
        }
      }}
      options={{
        filtering: true,
        columnsButton:true,
        exportButton: true,
        
        headerStyle: {
          backgroundColor: '#43A047 ',
          color: '#FFF',

        },
        rowStyle: rowData => ({
          backgroundColor: (selectedRow === rowData.tableData.id) ? '#EEE' : '#FFF'
        }),
        tableLayout: 'fixed'
      }
      }>

      </MaterialTable>
    </div>
    

   
   
  )
}

export default Home